import { useState } from "react";
import ModuleView from "@/components/shieldx/ModuleView";
import { Panel } from "@/components/shieldx/Primitives";
import { apiPost } from "@/lib/shieldx";
import { Fingerprint, Play } from "lucide-react";

const DEC = { ALLOW: "text-emerald-400", CHALLENGE: "text-cyan-300", BLOCK: "text-red-400" };

function probe() {
  const sig = { canvas: "UNAVAILABLE", webgl: "UNAVAILABLE", shader: "UNAVAILABLE", headless: !!navigator.webdriver, webdriver: !!navigator.webdriver };
  try {
    const c = document.createElement("canvas");
    const ctx = c.getContext("2d");
    if (ctx) { ctx.fillStyle = "#123"; ctx.fillRect(0, 0, 10, 10); ctx.fillText("sx", 2, 8); c.toDataURL(); sig.canvas = "PASS"; }
    const gl = c.getContext("webgl") || c.getContext("experimental-webgl");
    if (gl) { sig.webgl = "PASS"; sig.shader = gl.getParameter(gl.VERSION) ? "PASS" : "PARTIAL"; }
  } catch { /* leave as unavailable */ }
  return sig;
}

export default function BrowserIntegrity() {
  const [rpm, setRpm] = useState(120);
  const [authz, setAuthz] = useState("VALID");
  const [result, setResult] = useState(null);
  const run = async () => {
    const s = probe();
    setResult(await apiPost("/browser/evaluate", { ...s, rpm, authorization: authz }));
  };
  return (
    <ModuleView name="browser-integrity" icon={Fingerprint}>
      <Panel title="Live Browser Integrity Challenge" desc="Runs a real Canvas + WebGL probe in YOUR browser; decision is server-side" className="mt-4" testid="bi-challenge">
        <div className="flex flex-wrap items-end gap-3">
          <div>
            <label className="font-mono text-[10px] uppercase tracking-widest text-slate-500">Simulated Rate /min</label>
            <input data-testid="bi-rpm" type="number" value={rpm} onChange={(e) => setRpm(+e.target.value)} className="mt-1.5 w-32 rounded-lg border border-slate-700 bg-slate-950/60 px-3 py-2 text-sm text-slate-200" />
          </div>
          <div>
            <label className="font-mono text-[10px] uppercase tracking-widest text-slate-500">Authorization</label>
            <select data-testid="bi-authz" value={authz} onChange={(e) => setAuthz(e.target.value)} className="mt-1.5 rounded-lg border border-slate-700 bg-slate-950/60 px-3 py-2 text-sm text-slate-200">
              {["VALID", "MISSING", "EXPIRED"].map((o) => <option key={o}>{o}</option>)}
            </select>
          </div>
          <button onClick={run} data-testid="bi-run" className="flex items-center gap-2 rounded-lg bg-blue-600 px-4 py-2 text-sm font-semibold text-white hover:bg-blue-500"><Play className="h-4 w-4" /> Run Challenge</button>
        </div>
        {result && (
          <div className="mt-4 rounded-lg border border-slate-800 bg-slate-950/50 p-4" data-testid="bi-result">
            <div className="flex items-center justify-between">
              <span className="font-mono text-[10px] uppercase tracking-widest text-slate-500">Classification: {result.classification}</span>
              <span className={`font-display text-xl font-bold ${DEC[result.decision] || "text-slate-200"}`}>{result.decision}</span>
            </div>
            <p className="mt-1.5 text-sm text-slate-300">{result.note}</p>
            <p className="mt-2 font-mono text-[11px] text-slate-500">canvas={result.canvas} · webgl={result.webgl} · shader={result.shader} · risk={result.risk} · signals: {result.signals.join(", ")}</p>
          </div>
        )}
      </Panel>
    </ModuleView>
  );
}
